import $ from 'jquery'

export const initContactLoader = () => {
  $("body").on("click", ".contact-loader", onContactLoaderClick)
}

const onContactLoaderClick = (e) => {
  e.preventDefault();
  const btn = e.currentTarget
  const url = btn.dataset.url
  $.get(url, {}, (response) => {
    if (response) {
      btn.setAttribute("href", "mailto:" + response)
      btn.setAttribute("target", "_blank")
      // btn.innerHTML = response
      btn.classList.remove("contact-loader")
      btn.click()
    }
  })
}